<template>
  <div id="integral">
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>商城用户&nbsp;/&nbsp;积分活动</span>
        </div>
        <div style="display: flex;flex-wrap: wrap;align-items: center;">
            <Provinces @gain='gainSS' v-if="clearId"></Provinces>
           <el-input class="elinputs" v-model="beginData.name" placeholder="活动标题"></el-input>
            <el-select v-model="beginData.isOpen" placeholder="是否开通" class="elinputs">
                <el-option
                    v-for="item in classify.class"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
            <el-date-picker style="width: 218px;margin-right: 16px;" v-model="beginData.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm" placeholder="截止时间">
            </el-date-picker>
            <el-button type="primary" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
            <el-button type="info" @click='reset'>重置</el-button>
        </div>
        <div class="tit">
            <Reset @clkBtn='theBtn'></Reset>
            <Xlsx :name="formname"></Xlsx>
        </div>
        <el-table :data="tableData" id="exportTab" @selection-change="handleSelectionChange" border stripe style="width: 100%">
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
            <el-table-column prop="name" label="活动标题" min-width="160"></el-table-column>areasName
            <!-- <el-table-column prop="areasName" label="地区名" min-width="130"></el-table-column> -->
            <!-- <el-table-column prop="deliveryAreaName" label="配送区域" min-width="130"></el-table-column> -->
            <!-- <el-table-column prop="supplierName" label="供应商" min-width="130"></el-table-column> -->

            <el-table-column prop="areasName" label="所属地区" min-width="160"></el-table-column>areasName
            <!-- <el-table-column label="配送方式" min-width="130">
                <template slot-scope="scope">
                    <p class="boldfont" v-if="scope.row.delivery==1">冷链配</p>
                    <p class="boldfont" v-if="scope.row.delivery==2">常温配</p>
                </template>
            </el-table-column> -->
            <el-table-column label="是否开通" min-width="130">
                <template slot-scope="scope">
                    <p class="boldfont" v-if="scope.row.isOpen" style="color:#67C23A">是</p>
                    <p class="boldfont" v-else style="color:#F56C6C">否</p>
                </template>
            </el-table-column>
            <el-table-column label="缩略图" width="200">
                <template slot-scope="scope">
                    <viewer>
                        <img class="sfzimg" :src="imgUrl+scope.row.imgUrl" />
                    </viewer>
                </template>
            </el-table-column>
            <!-- <el-table-column label="组图" width="200">
                <template slot-scope="scope">
                    <viewer>
                        <img class="sfzimg" v-for="(item,index) in scope.row.gallery.split(',')" :key="index" :src="imgUrl+item" />
                    </viewer>
                </template>
            </el-table-column> -->
            <el-table-column prop="integral" label="所需积分" sortable min-width="130"></el-table-column>
            <el-table-column prop="endTime" label="截止时间" width="180"></el-table-column>
            <el-table-column prop="addTime" label="添加时间" min-width="180"></el-table-column>
            <el-table-column prop="updateTime" label="修改时间" width="180"></el-table-column>
            <el-table-column label="操作" fixed="right" width="220">
                <template slot-scope="scope">
                <el-button size="mini" type="success" @click="handleEdit(1,scope.row,'integral:update')"><i class="el-icon-edit"></i> 编辑</el-button>
                <el-button size="mini" type="danger" @click="stop(scope.row,'integral:delete')"><i class="el-icon-delete"></i> 删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="paging">
            <span>
            共
            <i class="pagingNum">{{total}}</i> 条
            </span>
            <Paging :gopage="total" @pag="pag"></Paging>
        </div>
    </el-card>
    <el-dialog title="添加/编辑" :visible.sync="dialogFormVisible" width="60%" @close="dataClose">
        <el-form>
            <el-form-item label="* 所属地区：">
                <el-select v-model="sheng" placeholder="省份" @change="cksheng">
                    <el-option
                    v-for="item in shenglist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="shi" placeholder="城市" @change="ckshi" class="newRegions cty16">
                    <el-option
                    v-for="item in shilist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 活动标题：">
               <el-input placeholder="请输入活动标题" v-model="mydata.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 所需积分：">
               <el-input placeholder="请输入所需积分" v-model="mydata.integral" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 缩略图：" style='margin-bottom: 10px;'>
                <el-upload class="upload-demo" :action="URL" :limit="1" :on-remove="handleRemove" :on-success="handleAvatarSuccess" :data="newobj" ref="upload" :file-list="mydata.iconUrls" name="multipartFile" :headers="newhead" list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">选择缩略图，推荐尺寸800*600px，大小100k以内</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="* 开始时间：">
                <div class="block">
                    <el-date-picker v-model="mydata.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm" placeholder="开始时间">
                    </el-date-picker>
                </div>
            </el-form-item>
            <el-form-item label="* 截止时间：">
                <div class="block">
                    <el-date-picker v-model="mydata.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm" placeholder="截止时间">
                    </el-date-picker>
                </div>
            </el-form-item>
            <el-form-item label="* 详 情：" style="align-items: end;margin-top:16px">
                <editor-bar v-model="mydata.detail" :isClear="isClear" @change="change"></editor-bar>
            </el-form-item>
            <!-- <div style='min-height: 340px;'>
              <editor-bar v-model="mydata.detail" :isClear="isClear" @change="change"></editor-bar>
            </div> -->
            <el-form-item label="* 是否打开：">
                <el-radio v-model="mydata.isOpen" label=true>是</el-radio>
                <el-radio v-model="mydata.isOpen" label=false>否</el-radio>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible=false">取 消</el-button>
            <el-button type="primary" @click="puton()">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import Xlsx from "@/components/Xlsx";
import EditorBar from '@/components/Richtext';
import Reset from "@/components/Reset";
import Paging from '@/components/Paging';
import Provinces from '@/components/Provinces';
export default {
  name: "integral",
  components: {
    Xlsx,
    EditorBar,
    Reset,
    Paging,
    Provinces
  },
  data() {
    return {
        beginData:{
            presell:[{name:'是',id:true},{name:'否',id:false}],
            deliverys:[{name:'冷链配',id:'1'},{name:'常温配',id:'2'}],
            categoryId:null
        },
        tableData: [],
        pageNum: 1,
        pageSize: 10,
        dialogFormVisible: false,
        details:[],
        userdata: {},
        total: 0,
        btn: [],
        areaId: "",
        fullscreenLoading: true,
        formname: JSON.stringify({name:'商品列表',hint:'integral:export'}),
        imgUrl: this.$Public.imgUrl,
        isClear: false,
        sheng:'',
        shi:'',
        shenglist:[],
        shilist:[],
        mydata:{isOpen:'true'},
        multipleSelection:[],
        URL:`${this.$Public.URL}/api-r/upload/uploadImg`,
        videoURL:`${this.$Public.URL}/api-e/upload/uploadVideo`,
        newobj:{type:3},
        newhead:{
                accessToken:JSON.parse(sessionStorage.getItem('userdata')).token
        },
        iconUrl:'',
        picUrl:[],

        // 哇
        newRegion:[],
        classify:{class:[{id:true,name:'是'},{id:false,name:'否'}]},
        addstr:false,
        clearId:true
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    }
  },
  mounted() {
    let region = JSON.parse(localStorage.getItem('region'))
    region.forEach(x => {
        if(x.level==0){
            this.shenglist.push(x)
            this.sheng=x.id
        }
    });
    if(this.userdata.level==0){
        this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:region[0].id}),{headers:{accessToken:this.userdata.token}})
        .then(res=>{
            if(res.data.success){
                this.$set(this,'shilist',res.data.areaListInfoList)
            }
        })
    }else{
        region.forEach(x=>{
            if(x.level==1){
                this.shilist.push(x)
            }
        })
        if(this.shilist.length==1){
            this.shi=this.shilist[0].id
            this.mydata.areasId = this.sheng +','+ this.shilist[0].id
            this.mydata.areasName = this.userdata.areasName
        }
    }
  },
  methods: {
      //   判断当前点击的按钮
    theBtn(i){
        if(i==1){
            if(this.btn.indexOf('integral:add')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.handleEdit(0)
        }else if(i==2){
            if(this.btn.indexOf('integral:update')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            if(this.multipleSelection.length != 1){
                return this.$message('请勾选一项内容编辑')
            }
            this.handleEdit(1,this.multipleSelection[0])
        }else if(i==3){
            if(this.btn.indexOf('integral:delete')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.choice()
        }else if(i==4){
            this.query()
        }
    },
    change(val) {
      console.log(val)
    },
    //   多选配送区域获取选择城市
    ckps(){

    },
      // 图标处理
    handleRemove(file, fileList) {
        this.iconUrl = ''
    },
    handleAvatarSuccess(res, file) {
        this.iconUrl = res.url
    },
    //   多选删除
    choice(){
        if(this.multipleSelection.length == 0){
            return this.$message('请至少选择一项删除')
        }
        let arr = []
        this.multipleSelection.forEach(x=>{
            arr.push(x.id)
        })
        this.$confirm('此操作将删除选中内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let url = ``
            url = `/api-s/deleteShop/${arr.join(',')}`
            this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
            .then(res=>{
                if(res.data.success==true){
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    this.begin();
                }else{
                    alert(res.data.msg)
                }
            })
        }).catch(() => {
            return
        });
    },
    // 关闭清空内容
    dataClose(){
        if(this.shilist.length==1){
            this.mydata={isOpen:'true',areasId:this.sheng +','+ this.shilist[0].id,areasName:this.userdata.areasName}
        }else{
            this.shi = ''
            this.mydata={isOpen:'true'}
        }
        this.begin()
    },
    cksheng(val){
        this.$set(this,'shi','')
    },
    ckshi(val){
        this.mydata.areasId = this.sheng +','+ val
        let arr = []
        this.shenglist.forEach(x=>{
            if(this.sheng==x.id){
                arr.push(x.name)
            }
        })
        this.shilist.forEach(x=>{
            if(val==x.id){
                arr.push(x.name)
            }
        })
        this.mydata.areasName = arr.join(',')
    },
    //   多选编辑
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    //   确定
    puton(){
        // this.fullscreenLoading = true;
        if(this.mydata.areasId == undefined || this.mydata.areasId == ''){
            return this.$message.error('请选择所属地区')
        }
        if(!this.mydata.name||!this.mydata.integral||!this.iconUrl||!this.mydata.startTime||!this.mydata.endTime||!this.mydata.isOpen||!this.mydata.detail||this.mydata.detail == "<p><br></p>"){
            return this.$message.error('请完善必填信息')
        }
        // 图片转换
        this.mydata.imgUrl = this.iconUrl

        // 判断是点击哪个
        let url = ``
        if(this.mydata.stat==0){
            url = `/api-s/addIntegralShop`
        }else if(this.mydata.stat==1){
            url = `/api-s/updateIntegralShop`
        }
        this.$axios.post(url,this.$qs.stringify(this.mydata),{ headers: { accessToken: this.userdata.token } })
        .then(res => {
            if(res.data.success){
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
                this.dialogFormVisible = false
            }else{
                this.$message({
                    message:res.data.msg,
                    type: 'warning'
                })
            }
            this.$refs.upload.clearFiles();
        });
    },
    reset() {
      this.beginData = {deliverys:[{name:'冷链配',id:'1'},{name:'常温配',id:'2'}],presell:[{name:'是',id:true},{name:'否',id:false}],isOnSale:'true'},
      this.clearId = false
      this.$nextTick(function() {
          this.clearId = true
      })
      this.begin();
    },
    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.begin();
    },
    begin() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        name:this.beginData.name,
        adminAreasId: userdata.areasId,
        areaId:this.beginData.areaId,
        isOpen:this.beginData.isOpen,
        startTime:this.beginData.startTime
      });
      this.$axios.post(`/api-s/getIntegralShopList`, data, {headers: { accessToken: userdata.token }})
        .then(res => {
            this.fullscreenLoading = false;
            if(res.data.success){
                this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
                    this.$set(this, "tableData", res.data.pageInfo.list);
                });
                this.$set(this, "total", res.data.pageInfo.total);
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
            }else{
              this.$message(res.data.msg)
            }
        });
    },
    handleEdit(i,row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
        if(i == 0){
            this.mydata.stat = i
        }else if(i == 1){
            let _this = this
            row.stat = i
            row.isOpen += ''
            // 图片data还原
            this.iconUrl = row.imgUrl

            row.iconUrls = [{name:'分类图标',url:`${_this.imgUrl+row.imgUrl}`}]
            _this.sheng = Number(row.areasId.split(',')[0])
            _this.shi = Number(row.areasId.split(',')[1])
            _this.mydata = row
        }
        this.dialogFormVisible = true
    },
    // 删除
    stop(row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
      this.$confirm('此操作将删除该条内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let url = ``
          url = `/api-s/deleteShop/${row.id}`
          this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
          .then(res=>{
              if(res.data.success==true){
                  this.$message({
                      type: 'success',
                      message: res.data.msg
                  });
                  this.begin();
              }else{
                  alert(res.data.msg)
              }
          })
      }).catch(() => {
          return
      });
    },
    query() {
      this.fullscreenLoading = true;
      this.begin();
    },
    // 获取省市传入的id
    gainSS(i){
        this.beginData.areaId = i.id
    },
  }
};
</script>
<style>
#integral .editor{
    width: 100%;
}
#integral .el-date-editor.el-input,#integral  .el-date-editor.el-input__inner{
    width: 100%
}
.w-e-toolbar{
  flex-wrap: wrap;
}
#integral .el-input__inner {
  margin: 10px 0;
}
#integral .el-menu.el-menu--horizontal{
  margin-bottom: 14px;
}
#integral .el-menu-item.is-active{
  background: none
}
#integral .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#integral .el-tag{
  margin-right: 12px;
}
#integral .el-select {
  /* margin: 0 8px; */
    width: 100%;
}
#integral .el-upload__tip {
    display: inline-block;
    margin-left: 14px;
}
#integral .block{
    width: 100%
}
.input-new-tag{
  width: 20%
}
#integral .el-upload-list--picture .el-upload-list__item {
    /* float: left;
    margin-right: 2%; */
}
#integral .el-form-item__content {
    width: 100%;
    display: flex;
}
/* #article .el-form-item:first-child{
    align-items: end
} */
#integral .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#integral .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#integral .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#integral .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#integral .el-dialog__body{
  min-height: 150px !important;
}
#integral .el-dialog__body {
  height: 500px;
}
#integral .el-form-item{
    display: flex;
    align-items: center;
    margin-bottom:0
}
#integral .el-form-item__label{
    width: 188px;
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx{
      color: red;
    margin-left: 8px;
}
.summary>span:first-child{
    margin-right: 20px
}
.summary>span:first-child i{
    color:red
}
.summary>span:last-child i{
    color:green
}
.staimg{
    position: absolute;
    left: -26px;
    top: 10px;
    width: 18px;
}
.dtstat span{
    margin: 0 34px;
}
.addstr{
    margin-left: 16px;
    text-decoration: underline;
    color:red;
    cursor: pointer;
}
// .newRegion{
//     width: 46% !important;
// }
// .newRegions{
//     margin-left:4%
// }
</style>
